document.addEventListener('DOMContentLoaded', function() {
    const bmiI18n = window.cbThemeI18n?.bmi || {};
    const calculator = document.querySelector('[data-bmi-calculator]');

    if (!calculator) {
        return;
    }

    const heightInput = calculator.querySelector('[data-bmi-height]');
    const weightInput = calculator.querySelector('[data-bmi-weight]');
    const submitButton = calculator.querySelector('[data-bmi-submit]');
    const resultNode = calculator.querySelector('[data-bmi-result]');
    const statusNode = calculator.querySelector('[data-bmi-status]');

    const renderStatus = function(message) {
        if (statusNode) {
            statusNode.textContent = message;
        }
    };

    const calculate = function() {
        const height = Number.parseFloat(heightInput.value);
        const weight = Number.parseFloat(weightInput.value);

        if (!height || !weight || height <= 0 || weight <= 0) {
            resultNode.textContent = '00.00';
            renderStatus(bmiI18n.invalid);
            return;
        }

        const bmi = weight / Math.pow(height / 100, 2);
        const formattedBmi = bmi.toFixed(2);
        let category = bmiI18n.normal;

        if (bmi < 18.5) {
            category = bmiI18n.underweight;
        } else if (bmi >= 25 && bmi < 30) {
            category = bmiI18n.overweight;
        } else if (bmi >= 30) {
            category = bmiI18n.obesity;
        }

        resultNode.textContent = formattedBmi;
        renderStatus(bmiI18n.result.replace('%s', category));
    };

    submitButton.addEventListener('click', calculate);

    [heightInput, weightInput].forEach(function(input) {
        input.addEventListener('keydown', function(event) {
            if (event.key === 'Enter') {
                event.preventDefault();
                calculate();
            }
        });
    });
});